module.exports = __webpack_public_path__ + "img/modern-black-frame-right-shadowed.9e6dbc5c.png";